import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch catering service items for a specific restaurant
 * @param {number} restaurantId - The restaurant ID
 * @param {string} categoryId - The category ID (optional)
 * @param {string} language - The language parameter (default: 'en')
 * @param {number} currencyId - The currency ID (default: 3)
 * @returns {Promise<Array>} - Response data from the API
 */
export const getCateringPackages = async (
  restaurantId, 
  categoryId = "", 
  language = "en", 
  currencyId = 3
) => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.RESTAURANT}/${restaurantId}/catering-service-items?category_id=${categoryId}&language=${language}&currency_id=${currencyId}`
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
}; 